module.exports = __webpack_public_path__ + "static/media/house10.ffd781b9.png";